import { combineReducers } from "@reduxjs/toolkit";
import accountingSlice from "@/features/accountingSlice";
import adminSlice from "@/features/adminSlice";
import answerReviewsSlice from "@/features/answerReviewsSlice";
import chatsSlice from "@/features/chatsSlice";
import metaListSlice from "@/features/metaListSlice";
import pricesSlice from "@/features/pricesSlice";
import searchSlice from "@/features/searchSlice";
import sessionSlice from "@/features/sessionSlice";
import toastSlice from "@/features/toastSlice";
import usersSlice from "@/features/usersSlice";
export const rootReducer = combineReducers({
    session: sessionSlice,
    metalist: metaListSlice,
    users: usersSlice,
    toasts: toastSlice,
    chats: chatsSlice,
    search: searchSlice,
    answerReviews: answerReviewsSlice,
    admin: adminSlice,
    accounting: accountingSlice,
    prices: pricesSlice,
});
